/* HARLUX core motion - global singleton shared across every HARLUX section. */
(function () {
  if (window.__hxCoreInit) return;
  window.__hxCoreInit = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var touch  = window.matchMedia('(hover: none)').matches;
  var io = null;

  function observeReveal(scope) {
    if (!io) {
      io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.08, rootMargin: '0px 0px -8% 0px' });
    }
    (scope || document).querySelectorAll('.hx-r:not(.is-in)').forEach(function (el) { io.observe(el); });
  }

  var heroBgs = [], heroTexts = [], depths = [], gift = null, tilts = [], assures = [];
  function collect() {
    heroBgs   = [].slice.call(document.querySelectorAll('[data-hx-par]'));
    heroTexts = [].slice.call(document.querySelectorAll('[data-hx-herotext]'));
    depths    = [].slice.call(document.querySelectorAll('[data-hx-depth]'));
    gift      = document.querySelector('[data-hx-giftdepth]');
    tilts     = touch ? [].slice.call(document.querySelectorAll('[data-hx-tilt]')) : [];
    assures   = touch ? [].slice.call(document.querySelectorAll('[data-hx-assure]')) : [];
  }

  function centreOffset(r, h) { return (r.top + r.height / 2 - h / 2) / (h / 2); }

  var ticking = false;
  function frame() {
    var h = window.innerHeight;

    heroBgs.forEach(function (bg) {
      var host = bg.parentElement; if (!host) return;
      var hr = host.getBoundingClientRect();
      if (hr.bottom > 0 && hr.top < h) { bg.style.transform = 'translate3d(0,' + (-hr.top * 0.14) + 'px,0)'; }
    });
    heroTexts.forEach(function (t) {
      var host = t.parentElement; if (!host) return;
      var hr = host.getBoundingClientRect();
      if (hr.bottom > 0 && hr.top < h) { t.style.transform = 'translate3d(0,' + (hr.top * 0.05) + 'px,0)'; }
    });

    depths.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.bottom < -80 || r.top > h + 80) return;
      var c = centreOffset(r, h);
      el.style.transform =
        'perspective(1400px) rotateY(' + (c * 3.2).toFixed(2) + 'deg) rotateX(' +
        (c * -1.6).toFixed(2) + 'deg) scale(' + (1 + (1 - Math.min(Math.abs(c), 1)) * 0.02).toFixed(4) + ')';
    });

    tilts.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.bottom < -40 || r.top > h + 40) return;
      var c = centreOffset(r, h);
      el.style.transform =
        'perspective(900px) rotateX(' + (c * -2.8).toFixed(2) + 'deg) translate3d(0,' +
        (c * 4).toFixed(1) + 'px,0)';
    });

    assures.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.bottom < 0 || r.top > h) return;
      var c = centreOffset(r, h);
      el.style.transform = 'perspective(700px) rotateX(' + (c * -4).toFixed(2) + 'deg)';
    });

    if (gift) {
      var gr = gift.getBoundingClientRect();
      if (gr.bottom > 0 && gr.top < h) {
        var gc = centreOffset(gr, h);
        gift.style.transform =
          'perspective(1200px) translate3d(0,' + (gc * -14).toFixed(1) + 'px,0) scale(' +
          (1 + (1 - Math.min(Math.abs(gc), 1)) * 0.015).toFixed(4) + ')';
      }
    }

    ticking = false;
  }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }

  function wirePointerTilt(scope) {
    if (touch) return;
    (scope || document).querySelectorAll('[data-hx-tilt]').forEach(function (el) {
      if (el.dataset.hxTiltWired) return; el.dataset.hxTiltWired = '1';
      var raf = null;
      el.addEventListener('pointermove', function (ev) {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          var r = el.getBoundingClientRect();
          var x = (ev.clientX - r.left) / r.width - 0.5;
          var y = (ev.clientY - r.top) / r.height - 0.5;
          el.style.transform =
            'perspective(1100px) rotateY(' + (x * 7).toFixed(2) + 'deg) rotateX(' +
            (-y * 7).toFixed(2) + 'deg) translate3d(0,-5px,0)';
          raf = null;
        });
      });
      el.addEventListener('pointerleave', function () { el.style.transform = ''; });
    });
  }

  function wireShine(scope) {
    if (!touch) return;
    var lio = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('hx-lit'); lio.unobserve(e.target); } });
    }, { threshold: 0.55 });
    (scope || document).querySelectorAll('.hx-card-in').forEach(function (el) {
      if (el.dataset.hxShine) return; el.dataset.hxShine = '1'; lio.observe(el);
    });
  }

  function wireChips(scope) {
    var root = scope || document;
    var chips = root.querySelectorAll('[data-hx-chip]');
    var grid  = root.querySelector('[data-hx-grid]');
    var empty = root.querySelector('[data-hx-empty]');
    if (!grid || !chips.length) return;
    chips.forEach(function (ch) {
      if (ch.dataset.hxChipWired) return; ch.dataset.hxChipWired = '1';
      ch.addEventListener('click', function () {
        var v = ch.getAttribute('data-hx-chip');
        chips.forEach(function (c) {
          c.classList.toggle('is-on', c === ch);
          c.setAttribute('aria-pressed', c === ch ? 'true' : 'false');
        });
        var shown = 0;
        grid.querySelectorAll('.hx-card').forEach(function (card) {
          var ok = (v === '__all') || (card.getAttribute('data-hx-tag') === v);
          card.classList.toggle('is-out', !ok);
          if (ok) { shown++; card.classList.add('is-in'); }
        });
        if (empty) empty.hidden = shown > 0;
      });
    });
  }

  function wireFaq(scope) {
    (scope || document).querySelectorAll('[data-hx-faq]').forEach(function (f) {
      var btn = f.querySelector('.hx-f-q');
      var pan = f.querySelector('.hx-f-a');
      if (!btn || !pan || f.dataset.hxFaqWired) return;
      f.dataset.hxFaqWired = '1';
      btn.addEventListener('click', function () {
        var open = f.classList.contains('is-open');
        var scopeEl = f.parentElement || document;
        scopeEl.querySelectorAll('[data-hx-faq].is-open').forEach(function (o) {
          o.classList.remove('is-open');
          o.querySelector('.hx-f-a').style.height = '0px';
          o.querySelector('.hx-f-q').setAttribute('aria-expanded', 'false');
        });
        if (!open) {
          f.classList.add('is-open');
          pan.style.height = pan.firstElementChild.offsetHeight + 'px';
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  function wireAll(scope) {
    observeReveal(scope);
    if (!reduce) { wirePointerTilt(scope); wireShine(scope); }
    wireChips(scope);
    wireFaq(scope);
    if (!reduce) { collect(); onScroll(); }
  }

  function boot() {
    wireAll(document);
    if (!reduce) {
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Theme editor: re-wire a section that was just added or edited. */
  document.addEventListener('shopify:section:load', function (e) { wireAll(e.target || document); });
})();
